import httpClient from ".";

export const API_CREDIT_PATH = "loan";
export const API_CREDIT_CATEGORY_PATH = "credit/category";

export const getAllCredits = data => httpClient.get(`${API_CREDIT_PATH}`, data);

export const getCreditsByClient = filter =>
  httpClient.get(`${API_CREDIT_PATH}${filter}`);

export const getCreditsMasseClient = clientId =>
  httpClient.get(`${API_CREDIT_PATH}/client/${clientId}`);

export const getAllCreditCategories = data =>
  httpClient.get(`${API_CREDIT_PATH}/categories`, data);

export const create = data => httpClient.post(API_CREDIT_PATH, data);
export const createCategory = data =>
  httpClient.post(API_CREDIT_CATEGORY_PATH, data);

export const edit = ({ id, ...data }) =>
  httpClient.put(`${API_CREDIT_PATH}/${id}`, data);

export const editCat = ({ id_cat: id, ...data }) =>
  httpClient.put(`${API_CREDIT_CATEGORY_PATH}/${id}`, data);

export const remove = id => httpClient.delete(`${API_CREDIT_PATH}/${id}`);

export const detail = creditId =>
  httpClient.get(`${API_CREDIT_PATH}/${creditId}`);
export const removeCategory = id =>
  httpClient.delete(`${API_CREDIT_CATEGORY_PATH}/${id}`);

export const updateMasse = data =>
  httpClient.post(`${API_CREDIT_PATH}/update-masse-credit`, data);
export const creditPayFast = ({ creditId, data }) =>
  httpClient.post(`${API_CREDIT_PATH}/${creditId}/pay-fast`, data);
export const creditTransform = (creditId, data) =>
  httpClient.post(`${API_CREDIT_PATH}/extend/${creditId}`, data);

export const getListTransactions = loanId =>
  httpClient.get(`${API_CREDIT_PATH}/transactions/${loanId}`);

export const updateTransactions = ({ transactionId, data }) =>
  httpClient.put(`${API_CREDIT_PATH}/transactions/${transactionId}`, data);

export const getStatistic = () =>
  httpClient.get(`${API_CREDIT_PATH}/statistics`);
